<template>
<div>
	<v-dialog v-model="worningBox" max-width="290">
      <v-card>
		<v-card-title class="warning py-5 d-flex justify-center" primary-title>
          <v-icon x-large color="white">mdi-alert-outline</v-icon>
        </v-card-title>
		<v-card-text class="pa-4 text-center">
			<h1>Warning</h1>
		</v-card-text>
		<v-card-text class="text-center pb-0">
			<h3 class="font-weight-light">Test credits exhausted</h3>
		</v-card-text>
		<v-card-actions class="text-center pa-4 d-flex justify-center">
			<v-btn @click="worningBox = false" rounded small class="px-8 text-capitalize" dark color="warning">Close</v-btn>
		</v-card-actions>
      </v-card>
    </v-dialog>
	<v-dialog v-model="viewModal" persistent max-width="590">
      <v-card>
		<v-icon class="close-btn" @click="viewModal = false">mdi-close</v-icon>
		<div v-if="editedItem.tests == null">
			<v-card-title class="body-1 grey--text font-weight-bold">File name</v-card-title>
			<v-card-title class="body-2 pt-0">
				<v-btn small :href="editedItem.file_url" target="_block" class="text-lowercase" rounded outlined>
					<v-icon color="primary" small left>mdi-file</v-icon>
					{{csvItems.name}}
				</v-btn>
			</v-card-title>
			<v-card-title class="body-1 grey--text font-weight-bold">Your Mapping</v-card-title>
			<v-simple-table>
				<template v-slot:default>
					<tbody>
						<tr v-for="(item, key, i) in csvItems.mapping" :key="i">
							<td class="pl-6">
								<b>{{++i}}. </b>
							</td>
							<td>
								{{key}}
							</td>
							<td><v-chip><v-icon small tile>mdi-arrow-right</v-icon></v-chip></td>
							<td>{{csvItems.mapping[key]}}</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div>
		<div v-else>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th class="text-left">URL</th>
							<th class="text-left">Country</th>
							<th class="text-left">Device</th>
							<th class="text-left">Version</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, i) in editedItem.tests" :key="i">
							<td>
								<span>{{++i}}. </span>
								{{item.url}}
							</td>
							<td>
								{{item.country}}
							</td>
							<td>
								{{item.platform}}
							</td>
							<td>
								{{item.version}}
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div>
		<v-card-title v-if="editedItem.emails != null" class="body-1 grey--text font-weight-bold">Emails</v-card-title>
        <v-simple-table v-if="editedItem.emails != null">
			<template v-slot:default>
				<tbody>
					<tr>
						<td>
							<v-chip v-for="(item, index) in editedItem.emails" :key="index" outlined small class="ml-2 mb-2">
								<v-avatar left>
									<v-icon color="red" small>mdi-email-send-outline</v-icon>
								</v-avatar>
								{{item}}
							</v-chip>
						</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
      </v-card>
    </v-dialog>
	<v-dialog v-model="Delete" max-width="500px">
        <v-card flat>
            <v-alert text prominent type="error" icon="mdi-delete">
                Are you sure you want to <b>Delete</b> this item?
            </v-alert>
            <v-card-actions class="pa-4 pt-0">
                <v-spacer></v-spacer>
                <v-btn color="red" class="text-capitalize" :loading="loading" text @click="deleteConfirm(editedItem)">
                    Delete
                </v-btn>
                <v-btn color="grey darken-1" class="text-capitalize" text @click="Delete = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
    <v-dialog v-model="csvModal" max-width="900px" content-class="modal-right">
        <v-card class="cus-card">
            <v-card-title>
                <span class="headline">{{ CSVTitle }}</span>
            </v-card-title>
            <v-card-text class="my-2">
                <v-stepper v-model="step" class="elevation-0" vertical>
                    <v-stepper-step :complete="step > 1" step="1" editable>
                        Filter
                        <small>Setup Filter</small>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                        <v-card flat class="pa-4 mb-12">
                            <v-alert v-if="mapError != ''" text dense border="left" type="error">
                                <span v-html="mapError"></span>
                            </v-alert>
							<v-alert v-if="maxAlert" dense border="left" type="warning">
								Maximum 2000 test only
							</v-alert>
							<v-alert v-if="mapError == '' && !maxAlert" dense border="left" colored-border type="info">
								Note : Only {{ userAccount.account.features ? userAccount.account.features.csv_tc : 2000 }} link are allowed in auto test csv.
							</v-alert>
							<v-form ref="csvform" v-model="csvValid" lazy-validation>
								<v-toolbar flat color="white" class="mb-4" v-if="changeMap">
									<v-toolbar-title class="caption">File name : {{filelabel}}</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn small color="success" text class="text-capitalize ml-8" :href="editedItem.file_url" target="_block" download>Download</v-btn>
								</v-toolbar>
								<v-file-input v-model="files" :label="filelabel" accept=".csv" :placeholder="placeholder" hide-details dense outlined @change="csvUpload">
									<template v-slot:selection="{ index, text }">
										<v-chip v-if="index < 2" color="primary lighten-1" dark label small>
											{{ text }}
										</v-chip>
										<span v-else-if="index === 2" class="overline grey--text text--darken-3 mx-2">
											+{{ files.length - 2 }} File(s)
										</span>
									</template>
								</v-file-input>
								<div v-if="csvItems.mapping == '' || editedIndex < -1">
									<v-btn href="/files/linktest.csv" class="text-capitalize float-right" color="success" text small download><v-icon small left>mdi-download</v-icon> Sample CSV File</v-btn>
								</div>
								<v-container v-if="csvItems.mapping != ''">
									<br>
									<h2 class="grey--text text--darken-2 mb-4">Map your CSV</h2>
									<v-row>
										<v-col cols="12" md="6" class="d-flex align-center" v-for="(item, key, i) in csvItems.mapping" :key="i">
											<v-row>
												<v-col cols="12" md="6" class="py-0">
													<v-chip color="white lighten-1" class="text-capitalize text--grey text--darken-2">
														<v-avatar left class="primary white--text">
															{{++i}}
														</v-avatar>
														<div class="font-weight-black">{{key == "platform" ? 'Device' : key}}</div>
													</v-chip>
												</v-col>
												<v-col cols="12" md="6" class="pa-0 d-flex justify-space-between" v-if="changeMap">
													<span class="body-1 mx-10">{{csvItems.mapping[key]}}</span>
												</v-col>
												<v-col cols="12" md="6" class="pa-0" v-else>
													
													<v-select v-if="mapOption.some(res => res.value === csvItems.mapping[key]) ? csvItems.mapping[key] : csvItems.mapping[key] = 'Skip this field'" v-model="csvItems.mapping[key]" hide-details :rules="[v => !!v || 'Field is required']" required :items="mapOption" item-text="name" item-value="value" dense outlined @change="ifError"></v-select>
													<v-select v-else v-model="csvItems.mapping[key]" :rules="[v => !!v || 'Item is required']" hide-details required :items="mapOption" item-text="name" item-value="value" dense outlined @change="ifError"></v-select>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
								</v-container>
							</v-form>
                        </v-card>
                        <v-btn :disabled="csvItems.mapping != '' ? mapError != '' ? true : false : true" color="primary" class="text-capitalize" @click="Step1">Continue</v-btn>
                    </v-stepper-content>
                    <v-stepper-step :complete="step > 2" step="2">
                        CSV Validation
                        <small>Setup CSV Validation</small>
                    </v-stepper-step>
                    <v-stepper-content step="2">
                        <v-card flat class="mb-12">
                            <v-container>
                                <div v-if="errors != ''">
                                    <v-alert v-for="(error, index) in errors" :key="index" text prominent type="error" icon="mdi-cloud-alert">
                                        <span v-html="error"></span>
                                    </v-alert>
                                </div>
                                <v-card v-else class="mx-auto text-center" max-width="500" flat>
                                    <v-img class="mx-auto" src="/images/done.png" lazy-src="/images/done.png" max-width="300" aspect-ratio="1.5">
                                        <template v-slot:placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                    <p class="text-center headline mb-0" v-text="'CSV PROVIDED IS VALID'"></p>
                                    <p class="text-center grey--text" v-text="'Please proceed to next step'"></p>
									<v-btn :disabled="errors != '' ? true : false" color="primary" class="text-capitalize" @click="step = 3">Continue</v-btn>
                       				<v-btn text class="ml-2 text-capitalize" @click="step = 1">Back</v-btn>
                                </v-card>
                            </v-container>
							<v-btn v-if="errors != ''" text class="ml-2 text-capitalize" @click="step = 1">Back</v-btn>
                        </v-card>
                    </v-stepper-content>

                    <v-stepper-step :complete="step > 3" step="3">
                        Settings
                        <small>Setup Settings</small>
                    </v-stepper-step>
                    <v-stepper-content step="3">
                        <v-card flat class="mb-12">
                            <v-container>
                                <label>Check periodically</label>
                                <v-radio-group v-model="csvItems.recurring" row>
                                    <v-radio label="Yes" value="true"></v-radio>
                                    <v-radio label="No" value="false"></v-radio>
                                </v-radio-group>
                            </v-container>
                            <v-container v-if="csvItems.recurring == 'true'">
                                <v-select v-model="csvItems.frequency" :items="['1 hour', '2 hour', '4 hour', '8 hour', '12 hour', '24 hour']" label="Check Frequency" dense outlined></v-select>
                                <v-select v-if="editedIndex > -1" v-model="csvItems.status" class="text-capitalize" :items="['active', 'paused']" label="Status" hide-details dense outlined></v-select>
                            </v-container>
                            <v-container>
                                <v-combobox v-model="csvItems.emails" label="Emails" dense multiple small-chips outlined></v-combobox>
                            </v-container>
                        </v-card>
                    </v-stepper-content>
                </v-stepper>
            </v-card-text>
            <v-card-actions class="pa-4">
                <v-btn color="primary" class="text-capitalize px-6" v-if="step == 3" :loading="loading" @click="saveCSV">Save</v-btn>
                <v-btn color="grey" class="text-capitalize" outlined @click="csvModal = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="manualModal" max-width="700px" content-class="modal-right">
        <v-card class="cus-card">
			<v-form ref="manual" v-model="manualValid" lazy-validation>
				<v-card-title>
					<v-toolbar-title>{{ ManualTitle }}</v-toolbar-title>
					<v-divider class="mx-4" inset vertical></v-divider>
					<v-btn fab dark small @click="addNewApartment" color="primary">
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="py-0">
					<v-container>
						<v-row>
							<v-col cols="12" v-if="manualItems.tests == ''">
								<div class="mt-4">
									<v-img class="mx-auto" src="/images/error.png" lazy-src="/images/error.png" aspect-ratio="2" max-width="400">
										<template v-slot:placeholder>
											<v-row class="fill-height ma-0" align="center" justify="center">
												<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
											</v-row>
										</template>
									</v-img>
									<p class="text-center headline mb-0 mt-4 font-weight-black">No Data</p>
								</div>
							</v-col>
							<v-col cols="12" v-if="manualItems.tests != ''">
								Test name : {{manualItems.name}} <v-btn @click.stop="isName = !isName" color="primary" icon><v-icon small v-text="isName ? 'mdi-close' : 'mdi-circle-edit-outline'"></v-icon></v-btn>
								<v-text-field v-if="isName" v-model="manualItems.name" label="Name" :rules="[v => !!v || 'name is required']" class="ma-0 mt-3 border-radius" dense outlined></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-expansion-panels v-model="panel" accordion>
									<v-expansion-panel v-for="(test, index) in manualItems.tests" :key="index">
										<v-expansion-panel-header disable-icon-rotate>
											<div class="d-flex justify-space-between">
												<span>{{++index}} {{test.url}}</span> <span class="mr-2"><span class="text-capitalize"><v-icon :color="test.platform == 'android_phone' ? 'success' : test.platform == 'windows_desktop' ? 'primary' : ''" v-text="test.platform == 'android_phone' ? 'mdi-android' : test.platform == 'android_tablet' ? 'mdi-tablet' : test.platform == 'ios_iphone' ? 'mdi-apple' : test.platform == 'ios_ipad' ? 'mdi-tablet-ipad' : 'mdi-microsoft-windows'"></v-icon></span> <v-chip color="grey lighten-5" small label class="text-capitalize ml-2"><span :class="`flag-icon flag-icon-${test.country.toLowerCase()} mr-2`"></span> [{{test.country}}]</v-chip></span>
											</div>
											<template v-slot:actions>
												<v-btn small icon @click="removeApartment(--index)">
													<v-icon small>mdi-close</v-icon>
												</v-btn>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-card class="pa-4 pt-0" flat>
												<v-row>
													<div class="pr-4">
														<v-row>
															<v-col cols="12">
																<v-text-field v-model="test.url" :rules="linkUrl" :hide-details="manualValid" class="ma-0 border-radius" label="URL" dense outlined></v-text-field>
															</v-col>
															<v-col cols="12" sm="12">
																<v-autocomplete v-model="test.country" class="ma-0 border-radius" label="Country" :items="countryWithCode" outlined dense item-text="Country Name" item-value="Country" hide-details></v-autocomplete>
															</v-col>
															<v-col cols="12" :sm="test.platform != 'windows_desktop' ? '6' : '12'">
																<v-autocomplete v-model="test.platform" :rules="[v => !!v || 'Field is required']" class="ma-0 border-radius" label="Device" :items="os" item-text="name" item-value="value" outlined dense hide-details @change="check_os(test.platform, --index)"></v-autocomplete>
															</v-col>
															<v-col v-if="test.platform != 'windows_desktop'" cols="12" sm="6">
																<v-autocomplete v-model="test.version" :rules="[v => !!v || 'Field is required']" class="ma-0 border-radius" label="OS Version" :items="oo_version" outlined dense hide-details></v-autocomplete>
															</v-col>
														</v-row>
													</div>
												</v-row>
											</v-card>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-col>
						</v-row>
					</v-container>
					<div v-if="manualItems.tests != ''">
						<v-container v-if="editedIndex == -1">
							<label>Check periodically</label>
							<v-radio-group v-model="manualItems.recurring" row>
								<v-radio label="Yes" value="true"></v-radio>
								<v-radio label="No" value="false"></v-radio>
							</v-radio-group>
						</v-container>
						<v-container v-if="manualItems.recurring == 'true'">
							<v-select v-model="manualItems.frequency" :items="['1 hour', '2 hour', '4 hour', '8 hour', '12 hour', '24 hour']" label="Test Frequency" dense outlined></v-select>
							<v-select v-if="editedIndex > -1" v-model="manualItems.status" class="text-capitalize" :items="[{name: 'Active', value: 'active'},{name: 'Paused', value: 'paused'}]" label="Status" item-text="name" item-value="value" hide-details dense outlined></v-select>
						</v-container>
						<v-container>
							<v-combobox v-model="manualItems.emails" label="Emails" dense multiple small-chips outlined></v-combobox>
						</v-container>
					</div>
				</v-card-text>
				<v-card-actions class="pa-4">
					<v-btn color="primary" class="text-capitalize px-6" v-if="manualItems.tests != ''" :loading="loading" @click="saveManual">Save</v-btn>
					<v-btn color="grey" outlined class="text-capitalize" @click="close">Cancel</v-btn>
				</v-card-actions>
			</v-form>
        </v-card>
    </v-dialog>
    <v-card class="pa-1">
        <v-data-table :headers="headers" :loading="tableLoad" loading-text="Loading... Please wait" :search="search" :items="desserts" sort-by="calories" class="elevation-0">
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-dialog v-model="choose" max-width="600px" content-class="zoom-80">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" class="mb-2 text-capitalize" v-on="on" @click="addCSV">Add New</v-btn>
                        </template>
                        <v-card>
                            <v-icon class="close-btn" @click="choose = false">mdi-close</v-icon>
                            <v-card-title class="py-md-6 px-10">
                                <span class="headline primary--text">Bulk Offers Test</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container class="pt-0">
									<div style="font-size: 18px; text-align: center; margin-bottom: 20px;"><span style="font-size: 19px; font-weight: bold; font-style: italic;">Sit back and relax while we generate the auto reports for you</span> </div>
                                    <v-row>
                                        <v-col cols="12">
											<v-alert v-if="userAccount.type != 'credit'" type="warning" class="paid_alert">
												<v-row align="center">
													<v-col class="grow pa-0">Upgrade now to add csv</v-col>
													<v-col class="shrink pa-0">
														<v-btn small outlined light color="white" class="mr-2 text-capitalize" to="/plans">plans</v-btn>
													</v-col>
												</v-row>
											</v-alert>
                                            <v-card :disabled="userAccount.type != 'credit'" outlined class="pa-2" hover @click="createCSV">
                                                <v-img src="/images/image_2022_07_04T12_15_59_498Z.png" lazy-src="/images/image_2022_07_04T12_15_59_498Z.png" aspect-ratio="1.5">
                                                    <template v-slot:placeholder>
                                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                        </v-row>
                                                    </template>
                                                </v-img>
                                                <v-card-text>
													<div class="text-center mt-3" style="font-size: 24px; font-weight: 600;">
                                                    	Add CSV file
													</div>
													<div class="text-center">
														Add Tests via CSV
													</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
							<v-card-text style="font-size: 18px; text-align: center;">
								I want to lose time and <a @click="createManual" href="javascript:void(0)">test manually</a> instead
							</v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" outlined dense hide-details></v-text-field>
                </v-toolbar>
            </template>
            <template v-slot:item.last_checked="{ item }">
                <div>{{item.last_checked ? dateTime(item.last_checked) : '--'}}</div>
            </template>
			<template v-slot:item.tfreq="{ item }">
                <div>{{item.tfreq ? item.tfreq : '--'}}</div>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip small class="text-capitalize font-weight-bold" :color="item.status == 'active' ? 'light-green darken-2' : item.status == 'completed' ? 'primary' : 'orange accent-4'" :style="item.status == 'active' ? 'background: #689f3821 !important;' : item.status == 'completed' ? 'background: #388fc21a !important;' : 'background: #ec6a3312 !important;'" label outlined>
                    {{item.status}}
                </v-chip>
				<v-btn v-if="item.status != 'active' && item.status != 'completed'" class="ml-2" :loading="reload" @click="initialize" icon small><v-icon small>mdi-cached</v-icon></v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
				<div class="d-flex justify-center">
					<span class="table_actions">
						<v-btn v-if="item.recurring" icon class="mr-2" @click="editItem(item)">
							<v-icon small>mdi-circle-edit-outline</v-icon>
						</v-btn>
						<v-btn v-else icon class="mr-2" @click="viewItem(item)">
							<v-icon small>mdi-eye</v-icon>
						</v-btn>
						<v-btn icon class="mr-2" :to="{ name: 'Logs', params: { id: item._id }}">
							<v-icon small>mdi-text-box-outline</v-icon>
						</v-btn>
						<v-btn icon @click="deleteItem(item)">
							<v-icon small>mdi-delete</v-icon>
						</v-btn>
					</span>
				</div>
            </template>
        </v-data-table>
    </v-card>
</div>
</template>

<script>
import Papa from 'papaparse'
import Vue from 'vue'
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex"
import moment from 'moment'
export default {
    data: () => ({
		worningBox: false,
		maxAlert: false,
		viewModal: false,
		tableLoad: false,
		isName: false,
		reload: false,
		panel: 0,
		search: '',
		mapError: '',
		filelabel: 'Insert CSV file',
		placeholder: 'Select file',
        csvItems: {
            mapping: '',
            frequency: '24 hour',
            status: 'paused',
            recurring: 'true',
			emails: []
		},
		manualItems: {
            tests:[
				{
					"url": "",
					"country": "US",
					"platform": "android_phone",
					"version": "10.0"
				}
			],
            frequency: '24 hour',
            status: 'active',
            recurring: 'true',
			emails: [],
			name: ''
		},
		test: {
			"url": "",
			"country": "US",
			"platform": "android_phone",
			"version": "10.0"
		},
		step: 1,
		changeMap: false,
		Delete: false,
		csvValid: true,
		manualValid:true,
        choose: false,
        csvModal: false,
		manualModal: false,
		loading: false,
		mapOption : [
			{name: "URL", value: 'url'},
			{name: "Device", value: 'device'},
			{name: "Country", value: 'country'},
			{name: "OS Version", value: 'version'},
			{name: "Skip this field", value: 'Skip this field'}
		],
        csvArrays: [],
        files: [],
		errors:[],
		devices1: [],
		os: [],
		oo_version: [],
		country1: [],
		linkUrl: [ v => !!v || 'URL is required' ],
        headers: [{
                text: 'Test name',
                value: 'name'
            },
            {
                text: 'Status',
                value: 'status'
            },
            {
                text: 'Frequency',
                value: 'tfreq'
            },
            {
                text: 'Last Check',
                value: 'last_checked'
			},
			{
				text: 'Offer count',
				align: 'center',
                value: 'total_links'
            },
            {
                text: 'Actions',
                align: 'center',
                value: 'actions',
                sortable: false
            },
        ],
        desserts: [],
        editedIndex: -1,
        editedItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
        },
        defaultItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
        },
    }),
    computed: {
        ...mapGetters(['country', 'countryWithCode', 'devices', 'userAccount']),
        CSVTitle() {
            return this.editedIndex === -1 ? 'CSV Upload' : 'Edit CSV'
        },
        ManualTitle() {
            return this.editedIndex === -1 ? 'Add Manual' : 'Edit Manual'
        },
	},
	watch: {
      manualModal (val) {
        val || this.close()
	  },
	  csvModal (val) {
        val || this.close1()
	  }
    },
    created() {
        this.initialize()
    },
    methods: {
        ...mapActions(['GetResponse', 'DeleteResponse', 'PostResponse', 'PatchResponse']),
		...mapMutations(['SnackbarSuccess', 'UserAccount']),
		addCSV() {
			this.csvItems = { mapping: '', frequency: '24 hour', status: 'active', recurring: 'true', emails: [], name: '' }
			this.manualItems = { tests:[{ "url": "", "country": "US", "platform": "android_phone", "version": "10.0" } ], frequency: '24 hour', status: 'active', recurring: 'true', emails: [], name: '' }
			this.isName = false
			this.editedIndex = -1
			this.step = 1
			this.panel = 0
			this.maxAlert = false
			this.files = undefined
			this.filelabel = 'Insert CSV file'
			this.changeMap = false
			this.placeholder = "Select file"
			this.editedItem = {}
		},
        async initialize() {
			this.tableLoad = true
			this.reload = true
            try {
                let url = '/internal/v2/autotest'
                const data = (await this.GetResponse(url)).data
                if (data.success) {
					this.desserts = data.data.tests
					this.tableLoad = false
					this.reload = false
				}
				this.tableLoad = false
				this.reload = false
            } catch (err) {
				console.log(err)
				this.tableLoad = false
				this.reload = false
            }
        },
        createCSV() {
			if (this.userAccount.type == 'credit') {
				if (this.userAccount.credit.used >= this.userAccount.credit.total) {
					this.worningBox = true
					this.choose = false
				} else {
					this.csvModal = true
            		this.choose = false
				}
			}
		},
        createManual() {
			this.manualItems.name = 'test-manual-' + this.makeid(5)
            this.manualModal = true
			this.choose = false
		},
		viewItem(item){
			this.editedItem = Object.assign({}, item)
			this.viewModal = true
			this.csvItems = {
				mapping: item.mapping,
				frequency: item.tfreq,
				status: item.status,
				recurring: item.recurring ? 'true' : 'false',
				emails: item.emails ? item.emails : [],
				name: item.name
			}
		},
        editItem(item) {
			this.editedIndex = this.desserts.indexOf(item)
			this.editedItem = Object.assign({}, item)
			this.isName = false
			if (item.type == 'csv') {
				this.csvEdit(item)
			} else if (item.type == 'manual') {
				this.manualEdit(item)
			}
		},
		csvEdit(item) {
			this.step = 1
			this.csvModal = true
			this.csvItems = {
				mapping: item.mapping,
				frequency: item.tfreq,
				status: item.status,
				recurring: item.recurring ? 'true' : 'false',
				emails: item.emails ? item.emails : [],
				name: item.name
			}
			this.files = undefined
			this.filelabel = item.ofile
			this.changeMap = true
			this.placeholder = "Select New file"
		},
		manualEdit(item){
			this.manualModal = true
			this.manualItems = {
				tests: item.tests,
				frequency: item.tfreq,
				status: item.status,
				recurring: item.recurring ? 'true' : 'false',
				emails: item.emails ? item.emails : [],
				name: item.name
			}
		},
        deleteItem(item) {
            const index = this.desserts.indexOf(item)
            confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
        },
        async saveCSV() {
            if (this.editedIndex > -1) {
				var keys = Object.keys(this.csvItems.mapping);
            	for(var i=0;i<keys.length;i++){
					if (this.csvItems.mapping[keys[i]] == 'Skip this field') {
						delete this.csvItems.mapping[keys[i]]
					}
				}
				var newObj = this.csvItems.mapping
				var bodyFormData = new FormData();
				if (this.files != undefined) {
					let reverseList = (o,r={})=> Object.keys(o).map(x=>r[o[x]]=x)&&r;
					newObj = reverseList(this.csvItems.mapping)
					bodyFormData.append('csv', this.files);
					bodyFormData.append('name', this.files.name);
				}
				this.csvItems.emails.map(res => bodyFormData.append('emails[]', res) )
				if (this.csvItems.recurring == 'true') {
					bodyFormData.append('frequency', this.csvItems.frequency);
					bodyFormData.append('status', this.csvItems.status);
				}
				bodyFormData.append('mapping[url]', newObj['url']);
                bodyFormData.append('mapping[version]', newObj['version']);
                bodyFormData.append('mapping[platform]', newObj['device']);
				bodyFormData.append('mapping[country]', newObj['country']);

				try {
                    let value = { url: `/internal/v2/autotest/${this.editedItem._id}/csv`, data: bodyFormData }
					const data = (await this.PatchResponse(value)).data
                    if (data.success) {
                        localStorage.setItem("credit", JSON.stringify(data.data.credit))
						this.UserAccount()
						this.initialize()
						this.loading = false
						this.csvModal = false
                        let dataMsg = { success: true, message: data.message, action: 'success' }
                        this.SnackbarSuccess(dataMsg)
                    } else {
						this.loading = false
                        let dataMsg = { success: true, message: data.message, action: 'error' }
                        this.SnackbarSuccess(dataMsg)
                    }
                } catch (err) {
					this.loading = false
                    let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
                    this.SnackbarSuccess(dataMsg)
                }
            } else {
				var keys = Object.keys(this.csvItems.mapping);
            	for(var i=0;i<keys.length;i++){
					if (this.csvItems.mapping[keys[i]] == 'Skip this field') {
						delete this.csvItems.mapping[keys[i]]
					}
				}
				this.loading = true
                let reverseList = (o,r={})=> Object.keys(o).map(x=>r[o[x]]=x)&&r;
				var newObj = reverseList(this.csvItems.mapping)
                var bodyFormData = new FormData();
                bodyFormData.append('csv', this.files);
                this.csvItems.emails.map(res => bodyFormData.append('emails[]', res) )
                bodyFormData.append('recurring', this.csvItems.recurring == 'true' ? true : false );
                if (this.csvItems.recurring == 'true') {
                    bodyFormData.append('frequency', this.csvItems.frequency);
                }
                bodyFormData.append('mapping[url]', newObj['url']);
                bodyFormData.append('mapping[version]', newObj['version']);
                bodyFormData.append('mapping[platform]', newObj['device']);
				bodyFormData.append('mapping[country]', newObj['country']);
				bodyFormData.append('name', this.files.name);

                try {
                    let value = { url: '/internal/v2/autotestcsv', data: bodyFormData }
                    const data = (await this.PostResponse(value)).data
                    if (data.success) {
                        localStorage.setItem("credit", JSON.stringify(data.data.credit))
						this.UserAccount()
						this.initialize()
						this.loading = false
						this.csvModal = false
                        let dataMsg = { success: true, message: data.message, action: 'success' }
                        this.SnackbarSuccess(dataMsg)
                    } else {
						this.loading = false
                        let dataMsg = { success: true, message: data.message, action: 'error' }
                        this.SnackbarSuccess(dataMsg)
                    }
                } catch (err) {
					this.loading = false
                    let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
                    this.SnackbarSuccess(dataMsg)
                }
                
            }
		},
		async saveManual(){
			if (this.editedIndex > -1) {
				if (this.$refs.manual.validate()) {
					delete this.manualItems.recurring
					let value = {
						url: `/internal/v2/autotest/${this.editedItem._id}/manual`,
						data: this.manualItems
					}
					try {
						const data = (await this.PatchResponse(value)).data
                        if (data.success) {
                            localStorage.setItem("credit", JSON.stringify(data.data.credit))
							this.UserAccount();
							this.initialize()
							this.loading = false
							this.manualModal = false
                            let dataMsg = { success: true, message: data.message, action: 'success' }
                            this.SnackbarSuccess(dataMsg)
                        } else {
							this.loading = false
                            let dataMsg = { success: true, message: data.message, action: 'error' }
                            this.SnackbarSuccess(dataMsg)
                        }
                    } catch (err) {
						this.loading = false
                        let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
                        this.SnackbarSuccess(dataMsg)
                    }
				}
			} else {
				const withHttp = url => !/^https?:\/\//i.test(url) ? `http://${url}` : url;
				this.manualItems.tests.map(res => {
					if (res.url) {
						res.url = withHttp(res.url);
					}
				})
				if (this.$refs.manual.validate()) {
					delete this.manualItems.status
					try {
                        let value = {
							url: '/internal/v2/autotest',
							data: this.manualItems
						}
						const data = (await this.PostResponse(value)).data
                        if (data.success) {
                            localStorage.setItem("credit", JSON.stringify(data.data.credit))
							this.UserAccount();
							this.initialize()
							this.loading = false
							this.manualModal = false
                            let dataMsg = { success: true, message: data.message, action: 'success' }
                            this.SnackbarSuccess(dataMsg)
                        } else {
							this.loading = false
                            let dataMsg = { success: true, message: data.message, action: 'error' }
                            this.SnackbarSuccess(dataMsg)
                        }
                    } catch (err) {
						this.loading = false
                        let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
                        this.SnackbarSuccess(dataMsg)
                    }
				}
			}
		},
        // date range
        dateTime(date) {
            return moment(date).format('MMMM Do YYYY h:mm a');
        },
        // csv Upload
        csvUpload() {
            this.csvItems.mapping = ''
            if (this.files != null) {
                Papa.parse(this.files, {
                    header: false,
                    columns: true,
                    complete: results => {
                        let err = false
                        const regex = '^([a-zA-Z0-9_]+)$'
                        let listarr = []
                        let headers = results.data[0]
                        for (const index in headers) {
                            if (!headers[index].match(regex)) {
                                err = true
                                listarr.push(headers[index])
                                this.files = null
                                break;
                            }
                        }
                        if (!err) {
                            var response = {}
                            headers.map(res => {
                                response[res] = res
                            })
							this.csvItems.mapping = response
							this.filelabel = 'Insert CSV file'
							this.changeMap = false
							this.placeholder = "Select file"
						}
						this.csvArrays = results.data;
						var rowLen = this.userAccount.account.features ? this.userAccount.account.features.csv_tc : 2000
						if (this.csvArrays.length > ++rowLen) {
							this.maxAlert = true
							this.csvItems.mapping = []
						}else {
							this.maxAlert = false
						}
                    }
                });
            }
		},
		// manual test
		addNewApartment() {
			const withHttp = url => !/^https?:\/\//i.test(url) ? `http://${url}` : url;
			this.manualItems.tests.map(res => {
				if (res.url) {
					res.url = withHttp(res.url);
				}
			})
			if (this.$refs.manual.validate()) {
				this.manualItems.tests.push(Vue.util.extend({}, this.test))
				var len = this.manualItems.tests.length
				this.panel = --len
			}
		},
		removeApartment(index) {
			Vue.delete(this.manualItems.tests, index);
			var len = this.manualItems.tests.length
			this.panel = --len
		},
        // Step 1
        Step1(){
			if (!this.changeMap) {
				if (this.$refs.csvform.validate()) {
					let devices = [], country = [], error = []
					this.devices.map( res => devices.push(res.value) )
					this.country.map( res => country.push(res.Country) )

					var newObj = {}
					for (let key in this.csvItems.mapping) {
						let i = this.csvArrays[0].indexOf(key)
						newObj[this.csvItems.mapping[key]] = i
					}

					let rows = this.csvArrays
					let len = rows.length
					if (len <= 1 && len >2000) {
						//ERRROR
						return;
					}

					for (let index = 1; index < len;index++) {
						let e = []
						let rowNumber = index + 1;
						let row = rows[index];

						let rowDevice = row[newObj['device']]
						if (!devices.includes(rowDevice)) {
							e.push(`Device - ${rowDevice} not supported. Only support (windows_desktop, ios_iphone, ios_ipad, android_phone, android_tablet)`);
						}
						let rowCountry = row[newObj['country']]
						if (!country.includes(rowCountry)) {
							e.push(`Invalid Country - ${rowCountry}`);
						}
						let rowVersion = row[newObj['version']]
						if (rowVersion !== '' && Number.isNaN(parseInt(rowVersion))) {
							e.push(`Invalid OS version - ${rowVersion}`);
						}
						let rowUrl = row[newObj['url']]
						if (rowUrl) {
							var urlR = /^https?:\/\//;
							var url = rowUrl.match(urlR);
							if (!url) {
								e.push(`Invalid url - ${rowUrl}`);
							}
						} else {
							e.push(`Invalid url - ${rowUrl}`);
						}
						if (e && (e.length > 0)) {
							let err = `Error on line ${rowNumber} : ${e.join(' | ')}`
							error.push(err);
						}
					}
					this.errors = error
					this.step = 2
				}
			} else {
				this.step = 2
			}
        },
        // If any Error in mapping input then show error
        ifError(){
            var keys = Object.keys(this.csvItems.mapping);
            var dupe = [];
            for(var i=0;i<keys.length;i++){
                for(var j=i+1;j<keys.length;j++){
					if (this.csvItems.mapping[keys[i]] != 'Skip this field') {
						if(this.csvItems.mapping[keys[i]] === this.csvItems.mapping[keys[j]] && this.csvItems.mapping[keys[i]] != ''){
							dupe.push(this.csvItems.mapping[keys[i]])
						}
					}
                }
            }
            let e = ''
			dupe.sort();
            dupe.forEach(function (value, index, arr){
                let first_index = arr.indexOf(value);
				let last_index = arr.lastIndexOf(value);
                if(first_index !== last_index){
                    e = value + ' ' + index + ' items Duplicate'
                }else{
                    e = 'Duplicate item ' + value
                }
			});
			this.mapError = e
		},
		deleteItem(item) {
            this.editedIndex = this.desserts.indexOf(item)
			this.editedItem = Object.assign({}, item)
            this.Delete = true
        },
        async deleteConfirm(item) {
            this.loading = true
            try {
                let url = `/internal/v2/autotest/${item._id}`
                const data = (await this.DeleteResponse(url)).data
                if (data.success) {
                    this.Delete = false
                    this.loading = false
                    this.initialize()
                }
                this.loading = false
            } catch (err) {
                this.loading = false
				let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
				this.SnackbarSuccess(dataMsg)
            }
		},
		check_os(item, index){
			this.devices.map( res => {
				if (res.value == item) {
					if (item != 'windows_desktop') {
						this.oo_version = res.ver
						this.manualItems.tests[index].version = res.v_selected
					} else {
						this.manualItems.tests[index].version = '10.0'
					}
				}
			} )
		},
		close () {
			this.addCSV()
			this.$refs.manual.resetValidation()
			this.manualModal = false
			this.maxAlert = false
			this.$nextTick(() => {
				this.editedIndex = -1
			})
		},
		close1 () {
			this.$refs.csvform.resetValidation()
			this.csvModal = false
			this.maxAlert = false
			this.$nextTick(() => {
				this.editedIndex = -1
			})
		},
		makeid(length) {
			var result = '';
			var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			var charactersLength = characters.length;
			for ( var i = 0; i < length; i++ ) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		}
	},
	mounted() {
		const enableAutoTestPopup = JSON.parse(localStorage.getItem('enableAutoTestPopup'));
		if (!enableAutoTestPopup) {
			this.choose = true;
		}
		localStorage.setItem("enableAutoTestPopup", JSON.stringify(true));
        this.devices.map( res => this.os.push({name : res.text, value: res.value}) )
		this.country.map( res => this.country1.push(res.Country) )
		this.check_os(this.test.platform, 0)
	},
}
</script>

<style scope>
.hover:hover {
	background: #f7f7f7;
	cursor: pointer;
}

.paid_alert{
	margin-bottom: -60px !important;
    position: relative !important;
    z-index: 10;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
}
.table_actions{
	width: 80px;
    display: flex;
    justify-content: flex-end;
}
</style>
